// removed by extract-text-webpack-plugin
module.exports = {"title":"app-pages-SuccessResetPassword-__style___E5TB-","desc-title":"app-pages-SuccessResetPassword-__style___1ovTN","btn-login":"app-pages-SuccessResetPassword-__style___3Mbsd"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/SuccessResetPassword/style.css
// module id = 2509
// module chunks = 0